/**
 * @generated SignedSource<<28c200aae8d97ca3a7b7de879dc2e1cc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CountryEditMain_country$data = {
  readonly description: string | null;
  readonly id: string;
  readonly name: string;
  readonly " $fragmentType": "CountryEditMain_country";
};
export type CountryEditMain_country$key = {
  readonly " $data"?: CountryEditMain_country$data;
  readonly " $fragmentSpreads": FragmentRefs<"CountryEditMain_country">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CountryEditMain_country",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    }
  ],
  "type": "Country",
  "abstractKey": null
};

(node as any).hash = "1994468c9ab12baa4d12abfc04116ed7";

export default node;
